<template>
    <div v-if="flow" class="max-w-(--breakpoint-md) w-full mb-2 md:mb-8 mx-auto">
        <vx-alert v-if="!editing"
            color="info"
            :closeable="false"
            shadow>
            <template v-slot:icon>
                <font-awesome-icon widthAuto :icon="faSlidersSimple"></font-awesome-icon>
            </template>
            <div class="flex items-center justify-between">
                <span><strong>Creating in</strong> {{ flow.name }}</span>
                <vx-button :href="flowLink"
                    size="sm"
                    color="info">Cancel<font-awesome-icon widthAuto :icon="faSquareArrowUpLeft"></font-awesome-icon></vx-button>
            </div>
        </vx-alert>
        <vx-alert v-else
            color="info"
            :closeable="false"
            shadow>
            <template v-slot:icon>
                <font-awesome-icon widthAuto :icon="faSlidersSimple"></font-awesome-icon>
            </template>
            <div class="flex items-center justify-between">
                <span><strong>In Flow:</strong> {{ flow.name }}</span>
                <vx-button :href="flowLink"
                    size="sm"
                    color="info">Go to Flow<font-awesome-icon widthAuto
                        :icon="faSquareArrowUpLeft"></font-awesome-icon></vx-button>
            </div>
        </vx-alert>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSlidersSimple, faSquareArrowUpLeft } from '@fortawesome/pro-solid-svg-icons';
import {
    VxAlert,
    VxButton
} from '@voxie/frontend-components';
import { onMounted, ref, computed } from "vue";
import { flowsClient } from "~/services";

const teamId = Spark.state.currentTeam.id;

const props = defineProps({
    flowId: {
        type: String,
        required: true,
    },
    flowSection: {
        type: Number,
    },
    editing: Boolean,
    resourceName: String
})

const flow = ref();

onMounted(async () => {
    flow.value = (await flowsClient.get(teamId, props.flowId)).data;
});

const flowLink = computed(() => '/automation/flows/' + props.flowId + '/resources' + (props.flowSection !== undefined ? '?flow_section=' + props.flowSection : ''));

defineExpose({
    flowLink,
});
</script>
